import { buttonProps as o } from "./index605.js";
import { definePropType as t } from "./index601.js";
const i = {
  /**
   * @description control the size of buttons in this button-group
   */
  size: o.size,
  /**
   * @description control the type of buttons in this button-group
   */
  type: o.type,
  /**
   * @description display direction
   */
  direction: {
    type: t(String),
    values: ["horizontal", "vertical"],
    default: "horizontal"
  }
};
export {
  i as buttonGroupProps
};
